import React from 'react'
import PropTypes from 'prop-types'
import Up from 'react-icons/lib/md/arrow-drop-up'
import Down from 'react-icons/lib/md/arrow-drop-down'
import Desktop from './Desktop'
import Mobile from './Mobile'
import MediaQuery from 'App/components/MediaQuery'

export default class Header extends React.Component {
  static propTypes = {
    orderBy: PropTypes.func,
    order: PropTypes.object
  }

  renderArrows = attr => {
    const { name, type } = this.props.order
    if (name === attr) {
      return type === 'asc' ? <Up /> : <Down />
    }
  }

  render() {
    return (
      <div>
        <MediaQuery size="desktop" style={{padding: '0 11px'}}>
          <Desktop
            orderBy={this.props.orderBy}
            renderArrows={this.renderArrows}
          />
        </MediaQuery>
        <MediaQuery size="mobile" style={{padding: '0 11px'}}>
          <Mobile
            orderBy={this.props.orderBy}
            renderArrows={this.renderArrows}
          />
        </MediaQuery>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Header/index.js